import type { ExternalToast } from 'sonner';

/**
 * Los avisos de la generación de reportes salen arriba, no en su lugar
 * habitual: la esquina inferior derecha la ocupa la ventana de progreso, y un
 * aviso encima la taparía justo cuando el usuario quiere verla.
 *
 * Es una opción por aviso, no una configuración global: el resto de la
 * aplicación conserva su posición de siempre.
 */
export const REPORT_TOAST_OPTIONS: ExternalToast = { position: 'top-center' };

export default REPORT_TOAST_OPTIONS;
